/*globals $:false */

import DomainDefinitionsP from './presenter/recordm.presenter.domaindefinitions.js';
import Ps from './recordm.permissions.js';

import tmpl from './templates/domains-and-defs-container.dot';

var DomainDefinitions = function(core) {

    var _$mainContainer,
        _domainsDefinitionsP;

    var _init = function(filter) {
        _$mainContainer = $(tmpl({
            canCreateDomains: core.hasPermission(Ps.DOMAIN_CREATE),
            canCreateDefinitions: core.hasPermission(Ps.DEFINITION_CREATE),
            filterPlaceholder: core.translateString('recordm.domains', 'filter-placeholder')
        }));

        core.translate("recordm.domains", _$mainContainer);

        _domainsDefinitionsP = new DomainDefinitionsP(core, _$mainContainer);

        _domainsDefinitionsP.init(filter);

        _$mainContainer.appendTo('#'+core.getAppInstanceId());
    };

    var _resume = function() {
        _$mainContainer.appendTo('#'+core.getAppInstanceId());
        _domainsDefinitionsP.resume();
    };

    var _pause = function() {
        _domainsDefinitionsP.pause();
        _$mainContainer.detach();
    };

    var _destroy = function() {
        _$mainContainer.remove();
        _domainsDefinitionsP.destroy();
    };

    return{
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,

        getDescription: function() {
            return {};
        }
    };
};

export default DomainDefinitions;
